export function shallHideElementsForScreenshot() {
  return false
}
